import React from 'react';
import { observer } from 'mobx-react';
import { ScheduleCalendarTemplate } from 'themes/application/schedule/pages';
import { setCurrentView } from 'core/utils';
import { ScheduleCalendarViewStore } from 'application/schedule/stores';

@setCurrentView((rootStore) => new ScheduleCalendarViewStore(rootStore), 'viewStore')
@observer
class ScheduleCalendar extends React.Component {
    render() {
        return <ScheduleCalendarTemplate {...this.props} />
    }
}

export default ScheduleCalendar;